import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { SidebarProvider } from './app/contexts/SidebarContext';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store/store';
import { AuthProvider } from './app/contexts/authContext';

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <AuthProvider>
                <SidebarProvider>
                    <App />
                </SidebarProvider>
            </AuthProvider>
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
